import classNames from 'classnames';
import { FC, ReactNode, PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as IClose } from '@/assets/icons/close.svg';
import styles from './index.less';


export interface DrawerProps {
  visible: boolean;
  width?: number;
  title?: ReactNode;
  footer?: ReactNode;
  onClose?: () => void;
}

const Drawer: FC<PropsWithChildren<DrawerProps>> = ({ visible, width = 300, title, footer, children, onClose }) => ReactDOM.createPortal(
  <div>
    <div className={classNames(styles.mask, { [styles.visible]: visible })} onClick={onClose} />
    <div className={classNames(styles.drawer, { [styles.visible]: visible })} style={{ width }}>
      {onClose && (
        <button className={styles.close} onClick={onClose}>
          <IClose />
        </button>
      )}
      {title ? (
        <header className={styles.header}>
          {(typeof title === 'string') ? <h3 className={styles.title}>{title}</h3> : title}
        </header>
      ) : null}
      <article className={styles.content}>{children}</article>
      {footer && <footer className={styles.footer}>{footer}</footer>}
    </div>
  </div>,
  document.getElementById('root')
);

export default Drawer;
